<div
    class="h-screen w-screen flex flex-col gap-10 items-center justify-center bg-white"
    [ngClass]="{'gap-10': isDesktop(), 'gap-4': !isDesktop()}">
    <h1 class="text-2xl" *ngIf="isDesktop()">Inserisci quì la tua firma</h1>
    <canvas #sigPad width="400px" height="400px" class="border-2 rounded-md bg-white" (touchmove)="onMouseDown($event)"
            (mousedown)="onMouseDown($event)"
            (mousemove)="onMouseMove($event)"></canvas>
    <div class="flex gap-2">
        <button mat-button class="bg-red-600 text-white" (click)="close()">Esci</button>
        <button mat-button class="bg-red-600 text-white" (click)="clear()">Pulisci</button>
        <button mat-button class="bg-primary-600 text-white" (click)="save()">Salva</button>
    </div>
</div>
